import { Button, Dropdown, Menu } from 'antd';
import React from 'react';
import SETTINGS_DARK from 'assets/img/black/settings.svg';
import SHARE_DARK from 'assets/img/black/share.svg';
import PIN_BLUE from 'assets/img/pin_blue.svg';
import PIN_GOLD from 'assets/img/pin_gold.png';
import ARROW from 'assets/img/play_arrow.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import SETTINGS from 'assets/img/settings.svg';
import SHARE from 'assets/img/share.svg';
import { CustomIcon, Badge } from '../../../../common';
import { ProjectsDropdown, ThemeSwitcher } from '../index';
import './style.scss';

export const ProjectNavbar = ({
  toggleState, handleNewProjectModal, selectedProject, showProjectsDropdown, handleShareModal,
  isDarkTheme, handleEditAddresses, handleAddressModal, projectSettings, switchTheme,
}) => (
  <div className="project_navbar">
    <div className="project_navbar_dropdown">
      <h2
        className="project_navbar_header"
        onClick={() => toggleState('showProjectsDropdown')}
      >{selectedProject}&nbsp;
        {!isDarkTheme && <CustomIcon src={ARROW} width="13px" height="6px" />}
      </h2>
      {showProjectsDropdown && <ProjectsDropdown isDarkTheme={isDarkTheme} />}
      <ThemeSwitcher switchTheme={switchTheme} isDarkTheme={isDarkTheme} />
    </div>
    <div className="project_navbar_row">
      <Button onClick={handleShareModal}><CustomIcon src={isDarkTheme ? SHARE_DARK : SHARE} />
        Share
      </Button>
      <Dropdown
        overlay={(
          <Menu>
            <Menu.Item key="0">
              <div className="project_badge_row" onClick={handleEditAddresses}>
                <p>Manage Adresses</p>
                <Badge count={12} />
              </div>
            </Menu.Item>
            <Menu.Item key="1" onClick={handleAddressModal}>
              Add Addresses
            </Menu.Item>
          </Menu>
        )}
        trigger={['click']}
      >
        <div className="project_badge_wrapper">
          <Button><CustomIcon src={isDarkTheme ? PIN_BLUE : PIN_GOLD} /> Addresses
            {!isDarkTheme && <CustomIcon src={isDarkTheme ? ARROW_BLUE : ARROW} width="13px" height="6px" />}
          </Button>
          <div className="project_badge">
            <Badge count={12} />
          </div>
        </div>
      </Dropdown>
      <Dropdown overlay={projectSettings} trigger={['click']}>
        <Button>
          <CustomIcon src={isDarkTheme ? SETTINGS_DARK : SETTINGS} />
          Project Settings&nbsp;
          {!isDarkTheme && <CustomIcon src={ARROW} width="13px" height="6px" />}
        </Button>
      </Dropdown>
      <button onClick={handleNewProjectModal} className="newProject" type="button">New Project</button>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/ProjectNavbar/index.js